import { render, staticRenderFns } from "./portrait.vue?vue&type=template&id=0c1f937e&scoped=true"
import script from "./portrait.vue?vue&type=script&lang=js"
export * from "./portrait.vue?vue&type=script&lang=js"
import style0 from "./portrait.vue?vue&type=style&index=0&id=0c1f937e&prod&lang=less"
import style1 from "./portrait.vue?vue&type=style&index=1&id=0c1f937e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f937e",
  null
  
)

export default component.exports